import {getCurrentInstance, computed, reactive} from 'vue';
import {ModuleProject} from '@/stores/moduleConst';
import {useStore} from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheProjectComboConfig = () => {
  const {proxy} = getCurrentInstance();

  const store = useStore();

  const projectCombo = computed(() => {
    const projects = store.getters[`${ModuleProject}/items`];
    return projects.filter(x => !x.inactive && !x.is_parent);
  });

  // config columns combo
  const cacheProjectComboConfig = reactive({
    data: projectCombo,
    columns: [
      {
        title: 'Mã CTMT, dự án',
        dataField: 'project_code',
        width: 140,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên CTMT, dự án',
        dataField: 'project_name',
        width: 310,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
      {
        title: 'Loại',
        dataField: 'object_type_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 140,
      },
    ],
    displayField: 'project_code',
    valueField: 'project_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'project_id',
      titleSearch: 'Tìm nhanh CTMT, dự án',
    },
  });

  return {cacheProjectComboConfig, projectCombo};
};
